import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class SetCypressHeaderInterceptor implements HttpInterceptor {
    public static CYPRESS_HEADER_NAME: string = 'x-s7-requests-is-cypress';
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (ETR.isCypress) {
            const requestClone = request.clone({
                headers: request.headers.set(SetCypressHeaderInterceptor.CYPRESS_HEADER_NAME, 'true')
            });
            return next.handle(requestClone);
        }
        return next.handle(request);
    }
}
